import {Currency} from './currency.model';
import { Country } from "app/models/country.model";
import {SupportTeam} from "app/models/supportTeam.model";

export interface OrganizationMetadata{
    workSchedule: WorkSchedule;
}

export interface WorkSchedule{
    applyParent: boolean;
    dayoffs?: Date[];
    weekdays?: DayOfWeekSchedule[];
}

export enum DayOfWeek{
    EveryDay = -1,
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Fridays,
    Saturday
}

export interface DayOfWeekSchedule {
    dayOfWeek: DayOfWeek,
    from: string,
    to: string,
}

export interface Organization extends CreateOrganization{
    id: string;
    children?: Organization[];
}

export interface CreateOrganization {
    name: string;
    supportTeam: SupportTeam;
    parentId: string | null;
    currency: Currency;
    language: string | null;
    additionalLanguages?: string[];
    timeZone: number | null;
    phone: number | null;
    managerPhone: number | null;
    latitude: number | null;
    longitude: number | null;
    country: Country | null;
    area?: string;
    city?: string;
    street?: string;
    house?: string;
    entrance?: string;
    flat?: string;
    intercom?: string;
    allowNotifyPos?: boolean;
    isActive: boolean;
    metadata: OrganizationMetadata;
    isLicensed: boolean;
}

export interface UpdateOrganization {
    organizationId: string;
    updatingData: CreateOrganization;
}

export interface TimeZone {
    value: number;
    countries: string;
    label: string;
    default: boolean;
    msk?: string;
}

export interface OrganizationAccess {
    organizationId: string;
    accessLevel: number;
    organizationName: string;
}

export interface OrganizationAccessWithParent extends OrganizationAccess{
  parentOrganizationId: string;
  parentOrganizationAccess: OrganizationAccess;
}
